import React from "react";
import Image from "react-image-webp";


export default function SpecialistBanner() {
  return <img src="/images/Short banner final.png" style={{width:"100%"}} alt="slide 1" />;
}
